import { render, staticRenderFns } from "./IconBdd.vue?vue&type=template&id=a4c55396&"
import script from "./IconBdd.vue?vue&type=script&lang=ts&"
export * from "./IconBdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports